module.exports = __webpack_public_path__ + "img/top-png-biaoti@3x.897c248b.png";